import { FunctionComponent, useState } from 'react';
import { createPortal } from 'react-dom';
import PopUp from '../../../../../components/popups/PopUp/PopUp';
import MainButton from '../../../../../components/buttons/MainButton/MainButton';
import styles from './ContactSupportPopUpBase.module.scss';
import classNames from 'classnames';
import GroupWithGap from '../../../../../components/lists/GroupWithGap/GroupWithGap';
import { ReactComponent as MailIcon } from '../../../../../asset/images/icons/mail.svg';
import { ReactComponent as PhoneIcon } from '../../../../../asset/images/icons/phone.svg';
import { ReactComponent as BubbleIcon } from '../../../../../asset/images/icons/bubble.svg';

interface ContactSupportPopUpBaseProps {
  name: string;
  positionText: string;
  image: string;
  email: string;
  telNumber: string;
  active: boolean;
  setActive(state: boolean): void;
}

const ContactSupportPopUpBase: FunctionComponent<ContactSupportPopUpBaseProps> = ({
  name,
  image,
  positionText,
  email,
  telNumber,
  active,
  setActive,
}) => {
  return (
    <>
      {createPortal(
        <PopUp className={styles['pop-up']} active={active} onPopUpStateChange={setActive} popUpWidth="400">
          <div className={styles['avatar-container']}>
            <img src={image} alt="Support person" />
          </div>

          <div className={styles['text-info-container']}>
            <p className={classNames(styles['name'], 'text text--h4')}>{name}</p>
            <p className={classNames(styles['position'], 'text text--body-2')}>{positionText}</p>
          </div>

          <GroupWithGap
            className={styles['button-group-container']}
            items={[
              <MainButton
                className={styles['button-type-1']}
                visualType="white"
                sizeType="medium"
                iconLeft={<MailIcon style={{ fill: 'var(--color-main)', width: '16px' }} />}
                onClick={() => (window.location.href = `mailto:${email}`)}
              >
                Email
              </MainButton>,
              <MainButton
                className={styles['button-type-1']}
                visualType="white"
                sizeType="medium"
                iconLeft={<PhoneIcon style={{ fill: 'var(--color-main)', width: '16px' }} />}
                onClick={() => (window.location.href = `tel:${telNumber}`)}
              >
                Phone Call
              </MainButton>,
              <MainButton
                className={styles['button-type-2']}
                visualType="main"
                sizeType="medium"
                iconLeft={<BubbleIcon style={{ fill: 'var(--color-white)', width: '16px' }} />}
                onClick={() => alert('Where should we point user?')}
              >
                Message Karla
              </MainButton>,
            ]}
          />
        </PopUp>,
        document.getElementById('modal') as HTMLElement
      )}
    </>
  );
};

export default ContactSupportPopUpBase;
